import React from "react";
import nodeHeights from "./utils/node-heights";

const useScrollTo = (
  target: string | React.RefObject<HTMLElement>,
  offsetBy?: (string | React.RefObject<HTMLElement>)[]
) => {
  const handler = (event?: React.MouseEvent) => {
    event && event.preventDefault();

    const node: HTMLElement | null =
      typeof target === "string"
        ? document.querySelector(target)
        : target?.current;

    if (!node?.tagName) return [() => {}];

    setTimeout(() => {
      window.scrollTo({
        behavior: "smooth",
        top:
          node.getBoundingClientRect().top +
          document.documentElement.scrollTop -
          nodeHeights(offsetBy)
      });
    }, 100);
  };

  return [handler];
};

export default useScrollTo;
